import { DropdownListOption } from "../components/search-dropdown/search-dropdown.component";

export const questionnaireType = {
  NOT_DEFINED: {name: 'Not Defined', value: 0},
  STANDARD_QNR: {name: 'Standard QNR', value: 1},
  SIMPLE_QNR: {name: 'Simple QNR', value: 2},
  SIMPLE_QNR_NO_NOTIFICATION: {name: 'Simple QNR - No Notification', value: 3},
  NO_QNR: {name: 'No QNR', value: 4}
};

export function getQuestionnaireType(value: number): string {
  const qt = Object.keys(questionnaireType).find(t => {
    return questionnaireType[t].value === value;
  });
  return qt ? questionnaireType[qt].name : '';
}

export function getQuestionnaireTypes(): DropdownListOption[] {
  const options: DropdownListOption[] =
    Object.keys(questionnaireType).map(
      (key, index) => ({
          id: questionnaireType[key].value,
          name: questionnaireType[key].name,
          value: questionnaireType[key].value,
          order: index,
      })
    );
  return options;
}
